import {Component, Input} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {UploadDocumentComponent} from "../../upload-document/upload-document.component";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {VoteComponent} from "../../vote/vote.component";
import {VOTE_OPTION} from "../../../models/enums";
import {MarkdownComponent} from "ngx-markdown";
import {environment} from "../../../../environments/environment";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {PartitionViewComponent} from "../../partitionComponents/partition-view/partition-view.component";
import {DocumentRepository} from "../../../repositories/document.repository";


@Component({
  selector: 'app-assistant-message',
  standalone: true,
  imports: [
    TranslateModule,
    MarkdownComponent
  ],
  templateUrl: './assistant-message.component.html',
  styleUrl: './assistant-message.component.css'
})
export class AssistantMessageComponent {
  @Input() message: any;
  @Input() chatId: any;
  processedText: SafeHtml | undefined;
  constructor(private modalService: NgbModal,private documentService: DocumentRepository,private sanitizer: DomSanitizer) {

  }
  async ngOnInit(): Promise<void> {

    this.replaceGuids(this.message?.rawData).then(safeHtml => {
      this.processedText = safeHtml;
    });

  }
  openUploadDialog(vote:VOTE_OPTION,messageId: string): void {
    const modalRef = this.modalService.open(VoteComponent, { size: 'sm' });
    modalRef.componentInstance.vote = vote;
    modalRef.componentInstance.messageId = messageId;
    modalRef.componentInstance.chatId = this.chatId;
    modalRef.result.then((result) => {
      if (result) {
        console.log('Vote uploaded successfully');
      }
    }).catch((error) => {
      console.error('Modal dismissed', error);
    });
  }
  async replaceGuids(text: string): Promise<SafeHtml> {
    const guidRegex = /\[([0-9a-fA-F-]{36})\]/g;
    const matches = Array.from(text.matchAll(guidRegex));
    console.log(matches);
    const guidMap: Record<string, string> = {};
    for (const match of matches) {
      const guid = match[1];
      if (!guidMap[guid]) {
        try {
          const matchingReference: any = this.getDataForGuid(guid);
          console.log(matchingReference);
          const document = await this.documentService.getDocument(matchingReference.documentId).toPromise();

          if (document && document.displayName) {
            guidMap[guid] = document.displayName;
          } else {
            console.warn(`Document not found or missing displayName for GUID: ${guid}`);
            guidMap[guid] = guid;
          }
        } catch (error) {
          console.error(`Error fetching document for GUID: ${guid}`, error);
          guidMap[guid] = guid;
        }
      }
    }
    const processedText = text.replace(guidRegex, (match, guid) => {
      const displayName = guidMap[guid] || guid;
      return `<span class="clickable-guid guid-${guid}" style="cursor: pointer;">[${displayName}]</span>`;
    });
    const withLineBreaks = processedText.replace(/\n/g, '<br>');
    return this.sanitizer.bypassSecurityTrustHtml(withLineBreaks);
  }
  onGuidClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (target && target.classList.contains('clickable-guid')) {
      const classList = Array.from(target.classList);
      const guidClass = classList.find((cls) => cls.startsWith('guid-'));
      if (guidClass) {
        const guid = guidClass.slice(5); // Remove the 'guid-' prefix
        this.handleClick(guid);
      } else {
        console.error('GUID class not found');
      }
    }
  }

  async handleClick(guid: string): Promise<void> {
    console.log('GUID clicked:', guid);
    const matchingReferece: any = this.getDataForGuid(guid);
    const tooltipDataRaw = this.documentService.getDocumentPartitionDetails(matchingReferece.documentId, matchingReferece.partitionId).subscribe(partition => {
      this.documentService.getDocument(matchingReferece.documentId).subscribe(document => {
        this.openDialog(partition,document);});
    });

  }

  openDialog(toolTipData:any,document: any) {

    const modalRef = this.modalService.open(PartitionViewComponent, {size: 'lg'});
    modalRef.componentInstance.partition= toolTipData;
    modalRef.componentInstance.document= document;
    modalRef.result.then((result) => {
      if (result) {
      }
    }).catch((error) => {
      console.error('Modal dismissed', error);
    });
  }
  getDataForGuid(guid: string): string {
  if (this.message?.tooling?.references) {    console.log(this.message?.tooling?.references);
      const matchingReference = this.message.tooling.references.find((ref: any) => ref.partitionId === guid);
      if (matchingReference) {
        return matchingReference;
      }
    }
    return 'No matching reference found for GUID';
  }

  protected readonly VOTE_OPTION = VOTE_OPTION;
  protected readonly environment = environment;
}
